import axios from "axios";
import RefreshTokenHandler from "../refreshToken/refreshToken";
import Config from "../config";

export const loginUser = async (email, password) => {
  try {
    const url = `${Config.baseUrl}/auth/login`;
    const result = await axios.post(url, {
      email,
      password,
      portal: "PATIENT",
    });
    return result;
  } catch (err) {
    throw err;
  }
};

export const getAllCurrency = async (email) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/currency/default?email=${email}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllCurrency(email);
      } else {
        throw err;
      }
    } else {
      throw err;
    }
  }
};

export const getAllCountry = async (email) => {
  try {
    const token = sessionStorage.getItem("token");
    const url = `${Config.baseUrl}/country/default?email=${email}`;
    const result = await axios.get(url, {
      headers: {
        Authorization: token || "",
      },
    });
    return result;
  } catch (err) {
    if (err.response.data.status === 401 || err.response.status === 403) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllCountry(email);
      } else {
        throw err.response;
      }
    } else {
      throw err.response;
    }
  }
};
